
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Home, Store, Rocket, Smartphone, Settings } from 'lucide-react';
import { cn } from '@/lib/utils';
import { Button } from '@/components/ui/button';

export const MobileBottomBar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname;
  
  // Navigation items with their routes, icons, and labels
  const navigationItems = [
    { path: '/', label: 'Home', icon: Home },
    { path: '/marketplace', label: 'Premium', icon: Store },
    { path: '/prop-trading', label: 'Prop', icon: Rocket },
    { path: '/mini-apps', label: 'Apps', icon: Smartphone },
    { path: '/settings', label: 'Settings', icon: Settings },
  ];
  
  // Check if current path matches or starts with the given path
  const isActive = (path: string) => {
    if (path === '/') {
      return currentPath === '/';
    }
    return currentPath.startsWith(path);
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 h-24 bg-background border-t border-border flex items-center justify-around z-50 safe-area-bottom shadow-xl mobile-nav-shadow">
      {navigationItems.map((item) => {
        const active = isActive(item.path);
        const IconComponent = item.icon;
        
        return (
          <Button
            key={item.path}
            variant="ghost"
            className={cn(
              "flex flex-col items-center justify-center h-full w-full rounded-none",
              "px-1 py-2",
              active ? "text-primary" : "text-muted-foreground"
            )}
            onClick={() => navigate(item.path)}
          >
            <IconComponent size={28} className={cn(active ? "text-primary" : "text-muted-foreground")} />
            <span className={cn(
              "text-sm mt-1.5",
              active && "font-medium"
            )}>{item.label}</span>
          </Button>
        );
      })}
    </div>
  );
};
